import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Clients extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      client: [],
      pinned: null,
      title: null  
    }

  }

  mount() {

   

   ScrollTrigger.create({
     trigger: this.ref.title,
     start: "top bottom",
     id: "trigger3",
     onEnter: ({
       progress,
       direction,
       isActive
     }) => {
       this.ref.title.classList.add("inview")
     },
     onLeaveBack: ({
       progress,
       direction,
       isActive
     }) => {
       this.ref.title.classList.remove("inview")
     }
   });

  
   

    
}






  unmount() {

    ScrollTrigger.getById("trigger3").kill();


  }


}

module.exports = Clients
